import { createSlice } from '@reduxjs/toolkit';
import { sendGeneralRequest} from '../generalRequest';

const initialState ={ 
    isPasswordSuccessfullyChanged: false,
    token: '',
    isLoading: false
};

export const forgotPasswordSlice = createSlice({
    name: 'forgotPassword',
    initialState,
    reducers:{
        setIsPasswordSuccessfullyChanged : (state, action) => {
            state.isPasswordSuccessfullyChanged = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(sendGeneralRequest.pending, (state) => {
                state.isLoading = true
            }) 
            .addCase(sendGeneralRequest.rejected, (state) => {
                state.isLoading = false
            }) 
            .addCase(sendGeneralRequest.fulfilled, (state, action) => {
                state.isLoading = false
                if(action.payload.endpoint === 'ChangePassword')
                {         
                    state.isPasswordSuccessfullyChanged = true    
                    state.token = action.payload.response.token
                    state.message = action.payload.response.errorMsg
                    state.success = action.payload.response.success
                }
                else if(action.payload.endpoint === 'ResetPasswordNew')
                {         
                    state.isPasswordSuccessfullyChanged = true    
                    state.message = action.payload.response.errorMsg
                    state.success = action.payload.response.success
                }
            })
        }
})

export const {setIsPasswordSuccessfullyChanged} = forgotPasswordSlice.actions;

export const selectForgotPasswordState = (state) => state.forgotPassword;

export default forgotPasswordSlice.reducer;